/**
 * =============================================
 * THE WHOO - Accordion Component 
 * =============================================
 * 
 * 📋 기능: 아코디언 열기/닫기 애니메이션
 * 🔧 특징: 여러 컴포넌트에서 안전하게 호출 가능
 * 🛡️ 중복방지: 같은 버튼에 여러번 이벤트가 등록되지 않음
 * 🔄 리사이징: 화면 크기 변경 시 높이 재계산
 * 
 * 사용법:
 * HTML: <div class="c-accordian">
 *         <button class="c-accordian__btn">제목</button>
 *         <div class="c-accordian__desc">내용</div>
 *       </div>
 */

(function () {

	// 설정값
	const MAX_HEIGHT = 440;
	const SCROLL_PARENTS = ['.product-info'];
	const RESIZE_DELAY = 250;

	// 디바운스 함수
	const debounce = (func, wait) => {
		let timeout;
		return (...args) => {
			clearTimeout(timeout);
			timeout = setTimeout(() => func(...args), wait);
		};
	};

	// 높이 설정 함수
	const setHeight = (desc, wrap, isOpen) => {
		if (!desc) return;

		if (isOpen) {
			const needsScroll = SCROLL_PARENTS.some(parent => wrap.closest(parent));
			const isOverLimit = desc.scrollHeight > MAX_HEIGHT && needsScroll;
			
			if (isOverLimit) {
				desc.style.maxHeight = MAX_HEIGHT + 'px';
				desc.style.overflow = 'auto';
			} else {
				desc.style.maxHeight = desc.scrollHeight + 'px';
				desc.style.overflow = '';
			}
		} else {
			desc.style.maxHeight = '0px';
			desc.style.overflow = '';
		}
	};

	// 열린 아코디언들 높이 재계산
	const recalculateHeights = () => {
		document.querySelectorAll('.c-accordian.c-accordian--active').forEach(wrap => {
			const desc = wrap.querySelector('.c-accordian__desc');
			setHeight(desc, wrap, true);
		});
	};

	// 아코디언 초기화
	const initAccordions = () => {
		document.querySelectorAll('.c-accordian__btn').forEach(btn => {
			// 중복 초기화 방지
			if (btn.hasAttribute('data-accordion-init')) return;
			btn.setAttribute('data-accordion-init', 'true');

			// 클릭 이벤트
			btn.addEventListener('click', () => {
				const wrap = btn.closest('.c-accordian');
				const desc = wrap.querySelector('.c-accordian__desc');
				
				wrap.classList.toggle('c-accordian--active');
				const isOpen = wrap.classList.contains('c-accordian--active');
				
				setHeight(desc, wrap, isOpen);
			});
		});
	};

	// 리사이징 이벤트 (전역 중복 방지)
	if (!window.accordionResizeInit) {
		window.addEventListener('resize', debounce(recalculateHeights, RESIZE_DELAY));
		window.accordionResizeInit = true;
	}

	// 실행
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAccordions);
	} else {
		initAccordions();
	}
	document.addEventListener('shopify:section:load', initAccordions);

})();

/*
// =============================================
// 📝 기존 코드 (참고용 - 주석처리)
// =============================================

(function () {

	// 🔧 추가: 디바운싱 함수
	const debounce = (func, wait) => {
		let timeout;
		return function executedFunction(...args) {
			const later = () => {
				clearTimeout(timeout);
				func(...args);
			};
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
		};
	};

	// 🔧 추가: 아코디언 높이 재계산 함수
	const recalculateAccordionHeight = (accordianWrap, accordianDesc) => {
		const scrollChck = [
			'.product-info',
		];
		
		if(accordianWrap.classList.contains('c-accordian--active')) {
			const scrollChckClass = scrollChck.some(selector => {
				return accordianWrap.closest(selector);
			});
			
			if(accordianDesc.scrollHeight > 440 && scrollChckClass) {
				accordianDesc.style.maxHeight = 440 + "px";
				accordianDesc.style.overflow = 'auto';
			} else {
				accordianDesc.style.maxHeight = accordianDesc.scrollHeight + "px";
			}
		}
	};

	// 🔧 추가: 모든 활성 아코디언 높이 재계산
	const recalculateAllAccordions = () => {
		const activeAccordions = document.querySelectorAll('.c-accordian.c-accordian--active');
		activeAccordions.forEach(accordianWrap => {
			const accordianDesc = accordianWrap.querySelector('.c-accordian__desc');
			if(accordianDesc) {
				recalculateAccordionHeight(accordianWrap, accordianDesc);
			}
		});
	};

	const cAccordian = () => {
		const accordianBtn = document.querySelectorAll('.c-accordian__btn');
		// accordian 스크롤 필요한 부모요소 리스트
		const scrollChck = [
			'.product-info',
		] 
		if(accordianBtn) {
			accordianBtn.forEach(btn => {
				// 🔧 추가: 중복 방지 - 이미 초기화된 버튼은 건너뛰기
				if(btn.hasAttribute('data-accordion-init')) {
					return;
				}
				btn.setAttribute('data-accordion-init', 'true');
				// 🔧 추가 끝

				const accordianWrap = btn.closest('.c-accordian');
				const accordianDesc = accordianWrap.querySelector('.c-accordian__desc');
				btn.addEventListener('click', () => {
					accordianWrap.classList.toggle('c-accordian--active');
					const scrollChckClass = scrollChck.some(selector => {
						return accordianWrap.closest(selector);
					});
					if(accordianWrap.classList.contains('c-accordian--active')) {
						if(accordianDesc.scrollHeight > 440 && scrollChckClass) {
							accordianDesc.style.maxHeight = 440 + "px";
							accordianDesc.style.overflow = 'auto';
						} else {
							accordianDesc.style.maxHeight = accordianDesc.scrollHeight + "px";
						}
					} else {
						accordianDesc.style.maxHeight = 0 + "px";
					}
					// if(scrollSet) scrollSet.lenisResize();
				})
			})
		}
	}

	// 🔧 추가: 리사이징 이벤트 처리 (디바운싱 적용)
	const debouncedResize = debounce(recalculateAllAccordions, 250);
	
	// 🔧 추가: 리사이징 이벤트 리스너 등록 (중복 방지)
	if(!window.accordionResizeListenerAdded) {
		window.addEventListener('resize', debouncedResize);
		window.accordionResizeListenerAdded = true;
	}

	document.addEventListener('shopify:section:load', cAccordian);
	cAccordian();

})();

*/